// Initial state for auth
const initialState = {
    userRoles: JSON.parse(localStorage.getItem('userRoles')) || [],
    isLoading: true,
  };
  
  // Reducer function
  const authReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_USER_ROLES':
        localStorage.setItem('userRoles', JSON.stringify(action.payload)); // Save to localStorage
        return {
          ...state,
          userRoles: action.payload,
          isLoading: false,
        };
      case 'SET_LOADING':
        return {
          ...state,
          isLoading: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default authReducer;
  